import * as React from 'react';
import { Link } from 'react-router-dom';

const arrowIcon = require('../../images/right-carot-large.png');

interface Props {
    iconSrc: string;
    text: string;
    destinationRoute: string;
}

const IndexLink = (props: Props) => {
    return (
        <Link to={props.destinationRoute} className="index-nav">
            <div>
                <div>
                    <img src={props.iconSrc} />
                </div>

                <span className="index-text">{props.text}</span>
            </div>
            <img src={arrowIcon} />
        </Link>
    );
};

export default IndexLink;



// WEBPACK FOOTER //
// ./src/components/common/IndexLink.tsx